export default {
  name: 'marking--inventoryImport',
  apiService: 'shoes',
  apiPath: '/admin/inventory_h/upload',
  urlParamName: 'marking--inventoryImport',
};